import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Event, PostEvent, PutEvent } from 'src/app/interfaces/api/event';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../core/api.service';

type QueryParams = Record<string, string | number | boolean | Date | Array<string | number | boolean | Date> | object>;

@Injectable({
  providedIn: 'root'
})
export class EventService {

  collection = "Event";
  collectionPath = "events";
  events: Event[] = [];
  apiUrl = environment.API_URL;

  constructor(
    public http: HttpClient,
    private apiService: ApiService
  ) { }

  //---GET---//

  getEvents(query: QueryParams = {}): Observable<Event[]> {
    return this.apiService.getCollection(this.collectionPath, "", query).pipe(
      tap((res: any) => {
        if (res) {
          localStorage.setItem('events', res);
        }
      }), catchError(err => throwError(err))
    );
  }

  getEvent(id: string): Observable<Event> {
    return this.apiService.getCollectionItem( this.collectionPath, "", id);
  }

  getValueList(field: string): Observable<any> {
    return this.apiService.getCollection(this.collectionPath, 'listValues', { field });
  }

  searchEvents(search: string, query: QueryParams = {}): Observable<Event[]> {
    return this.apiService.getCollection(this.collectionPath, 'search', { q: search, ...query });
  }

  exportEvents(query: QueryParams = {}) {
    return this.apiService.getCollection(this.collectionPath, 'export', query);
  }

  getEventsCount(query: QueryParams = {}): Observable<number> {
    return this.apiService.getCollection( this.collectionPath, 'count', query);
  }

  getEventByUnitId(unitId: string, trackerIds: string): Observable<Event> {
    return this.apiService.getCollection(this.collectionPath, "getByUnitId", { unitId, trackerIds });
  }

  //---POST---//

  addEvent(event: PostEvent): Observable<any> {
    return this.apiService.postCollectionData(this.collectionPath, "", event);
  }

  addEvents(events: PostEvent[]): Observable<any> {
    return this.apiService.postCollectionData(this.collectionPath, "many", events);
  }

  addStreamEvent(event: PostEvent): Observable<any> {
    return this.apiService.postCollectionData(this.collectionPath, "stream", event);
  }

  //---PUT---//

  updateEvent(event: PutEvent): Observable<any> {
    return this.apiService.updateCollectionItem(this.collectionPath, event);
  }

  updateStreamEvent(event: QueryParams): Observable<any> {
    return this.apiService.updateCollectionItem(this.collectionPath + "/stream", event);
  }

  //---DELETE---//

  removeEvent(id: string): Observable<any> {
    return this.apiService.deleteCollectionItem(this.collectionPath, id);
  }

  removeEvents(query: QueryParams = {}): Observable<any> {
    return this.apiService.deleteCollectionItems(this.collectionPath, query);
  }

}
